import React, { useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';

function AccountSummary() {
  const [bankId, setBankId] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [bankSummary, setBankSummary] = useState(null);
  const [customerSummary, setCustomerSummary] = useState(null);

  const fetchBankSummary = () => {
    axios.get(`/accounts/summary/bank/${bankId}`).then(res => setBankSummary(res.data));
  };

  const fetchCustomerSummary = () => {
    axios.get(`/accounts/summary/customer/${customerId}`).then(res => setCustomerSummary(res.data));
  };

  return (
    <div className="flex">
      
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Financial Summaries</h2>

        <div className="mb-8">
          <h3 className="text-lg font-semibold mb-2">Bank Summary</h3>
          <input
            className="border p-2 mr-2"
            placeholder="Bank ID"
            value={bankId}
            onChange={e => setBankId(e.target.value)}
          />
          <button onClick={fetchBankSummary} className="bg-blue-600 text-white px-4 py-2">Get Summary</button>
          {bankSummary && (
            <div className="mt-4 bg-gray-100 p-4 rounded">
              <p>Total Deposits: ${bankSummary.total_deposit}</p>
              <p>Total Withdrawals: ${bankSummary.total_withdrawal}</p>
              <p>Balance: ${bankSummary.balance}</p>
            </div>
          )}
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-2">Customer Summary</h3>
          <input
            className="border p-2 mr-2"
            placeholder="Customer ID"
            value={customerId}
            onChange={e => setCustomerId(e.target.value)}
          />
          <button onClick={fetchCustomerSummary} className="bg-blue-600 text-white px-4 py-2">Get Summary</button>
          {customerSummary && (
            <div className="mt-4 bg-gray-100 p-4 rounded">
              <p>Total Sales: ${customerSummary.total_sales}</p>
              <p>Total Paid: ${customerSummary.total_paid}</p>
              <p>Due Balance: ${customerSummary.balance}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AccountSummary;